import { type MaybeRefOrGetter, toValue } from 'vue'
import { queryOptions } from '@tanstack/vue-query'
import { fetchActivityLog } from '@/features/invoices/api/fetchActivityLog'

export const fetchActivityLogQueryOptions = (invoiceId: MaybeRefOrGetter<number>) => queryOptions({
  queryKey: ['invoices:activity', invoiceId],
  queryFn: () => fetchActivityLog(toValue(invoiceId))
})
